import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { MessagePlugin, Select } from 'tdesign-react';

import { INovel } from '@/interface/novel';
import { getNovelList } from '@/services/novel';

export interface IProps {
  onChange: (value: INovel[]) => void;
  value: INovel[];
}

const CustomNovelSelect: React.FC<IProps> = (props) => {
  const {
    onChange,
    value = [],
  } = props;

  const [v, setV] = useState<INovel[]>([]);
  const [novels, setNovels] = useState<INovel[]>([]);
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  const handleSearch = useCallback((value?: string) => {
    getNovelList({ novelName: value, page: 1, size: 999 }).then((res) => {
      setOptions(res.list.map(item => ({
        value: item.novelId,
        label: item.novelName,
      })));
      setNovels(pre => _.uniqBy([...pre, ...res.list], 'novelId'));
    })
      .catch((err) => {
        MessagePlugin.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (v.length === 0 && value.length > 0) {
      setV(value);
    }
  }, [v, value]);

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div
      style={{ display: 'block', width: '100%' }}
    >
      <Select filterable
        multiple
        value={value.map(({ novelId }) => novelId)}
        options={options}
        onSearch={handleSearch}
        onBlur={() => {
          setOptions(novels.map(({ novelId, novelName }) => ({ value: novelId, label: novelName })));
        }}
        onChange={(data: any) => {
          const newValue = novels.filter(({ novelId }) => data.includes(novelId));
          onChange(newValue);
          setV(newValue as any);
        }} />
    </div >
  );
};

export default CustomNovelSelect;
